import Vue from 'vue'
import App from './App.vue'
import axios from "axios"
import VueRouter from "vue-router"
import router from './common/router.js'
Vue.prototype.$http = axios //在Vue的原型上添加一个$http属性，该属性保存了axios

Vue.prototype.$indexurl = '' //在Vue的原型上添加一个$http属性，该属性保存了axios

axios.defaults.baseURL = 'https://mi-forest.com/api'
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
	  document.title = to.meta.title
	}
	next()
  })

Vue.use(VueRouter)
new Vue({
	router:router,
	render: h => h(App),
}).$mount('#app')